import React from 'react'
import { Spinner } from 'components'

const Loader = () => <Spinner size="big" />

export default Loader
